import request from '../utils/request';

/**
 * 统计数据API服务
 */
const statisticsApi = {
  /**
   * 获取平台概览统计数据
   * @param {string} timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {number} year - 年份（month和year时间范围时使用）
   * @param {number} month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getPlatformOverview: (timeRange = 'today', startDate, endDate, year, month) => {
    let params = { timeRange };
    
    if (timeRange === 'custom' && startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    
    if (timeRange === 'year' && year) {
      // 后端可能需要年份参数
      params.year = year;
    }
    
    if (timeRange === 'month' && year && month) {
      // 后端可能需要年份和月份参数
      params.year = year;
      params.month = month;
    }
 
    return request({
      url: '/statistics/overview',
      method: 'get',
      params
    });
  },
  
  /**
   * 获取每日数据统计
   * @param {string} startDate - 开始日期（格式：YYYY-MM-DD）
   * @param {string} endDate - 结束日期（格式：YYYY-MM-DD）
   * @returns {Promise} - 返回请求Promise
   */
  getDailyStatistics: (startDate, endDate) => {
    return request({
      url: '/statistics/daily',
      method: 'get',
      params: { startDate, endDate }
    });
  },
  
  /**
   * 按时间段类型获取数据统计
   * @param {Object} params - 请求参数对象
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.startDate - 开始日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {string} params.endDate - 结束日期（自定义时间范围时使用，格式：YYYY-MM-DD）
   * @param {number} params.year - 年份（month和year时间范围时使用）
   * @param {number} params.month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getStatisticsByPeriodType: (params = {}) => {
    const { timeRange = 'last7days', startDate, endDate, year, month } = params;
    
    let requestParams = { timeRange };
    
    if (timeRange === 'custom' && startDate && endDate) {
      requestParams.startDate = startDate;
      requestParams.endDate = endDate;
    }
    
    if (timeRange === 'year' && year) {
      requestParams.year = year;
    }
    
    if (timeRange === 'month' && year && month) {
      requestParams.year = year;
      requestParams.month = month;
    }
    console.log("requestParams", requestParams);
    return request({
      url: '/statistics/period',
      method: 'get',
      params: requestParams
    });
  },
  
  /**
   * 获取最近交易记录
   * @param {Object} params - 请求参数对象
   * @param {number} params.page - 页码
   * @param {number} params.size - 每页大小
   * @param {number} params.userId - 用户ID（可选）
   * @param {string} params.transactionType - 交易类型（可选）
   * @param {string} params.transactionStatus - 交易状态（可选）
   * @param {string} params.timeRange - 时间范围类型：today-今日, last7days-近七日, last30days-近30天, month-月份, year-年份, custom-自定义
   * @param {string} params.startTime - 开始时间（自定义时间范围时使用，格式：YYYY-MM-DD HH:mm:ss）
   * @param {string} params.endTime - 结束时间（自定义时间范围时使用，格式：YYYY-MM-DD HH:mm:ss）
   * @param {number} params.year - 年份（month和year时间范围时使用）
   * @param {number} params.month - 月份（month时间范围时使用）
   * @returns {Promise} - 返回请求Promise
   */
  getRecentTransactions: (params = {}) => {
    const { 
      page = 1, 
      size = 10, 
      userId, 
      transactionType, 
      transactionStatus, 
      timeRange = 'last7days', 
      startTime, 
      endTime,
      year,
      month
    } = params;
    
    let requestParams = { page, size, timeRange };
    
    if (userId) requestParams.userId = userId;
    if (transactionType) requestParams.transactionType = transactionType;
    if (transactionStatus) requestParams.transactionStatus = transactionStatus;
    
    if (timeRange === 'custom' && startTime && endTime) {
      requestParams.startTime = startTime;
      requestParams.endTime = endTime;
    }
    
    if (timeRange === 'year' && year) {
      requestParams.year = year;
    }
    
    if (timeRange === 'month' && year && month) {
      requestParams.year = year;
      requestParams.month = month;
    }
    
    return request({
      url: '/statistics/transactions',
      method: 'get',
      params: requestParams
    });
  }
};

export default statisticsApi; 